export default __webpack_public_path__ + "static/media/Icon-Right_Arrow_Hot.952203e6.svg";